module.exports = __webpack_public_path__ + "static/media/HCRA Notice of Proposal re Compliance Order - McCrea Excavating Ltd. - November 12- 2024.10d8df19.pdf";